module.exports = __webpack_public_path__ + "img/neotag-product2.f4566daa.jpg";